/* global moment swal angular */

import './style.less';

export default function($log, $filter, $sce, $stateParams, Swal, ApiClass, ProfileClass, PreviousState) {
  'ngInject';

  const vm = this;
  vm.$onInit = activate;

  const { profile_uid } = ProfileClass.profileComplete.profile;

  vm.profile_uid = profile_uid;

  const answersDict = {};

  vm.formData = {
    answers: {},
    submitted_answers: {},
    text_area: []
  };

  vm.answerLabel = ($index, question) => {
    if (!vm.activity) return;

    // Return label for completed activities
    if (vm.activity.progress && vm.activity.progress.completed)
      return $index === question.answer ? 'correct' : 'incorrect';

    // Return label for submitted answers
    if (vm.activity.preview_answers && vm.submitted && $index === vm.formData.submitted_answers[question.key]) {
      return vm.formData.submitted_answers[question.key] === question.answer ? 'correct' : 'incorrect';
    }
  };

  vm.submit = formData => {
    if (vm.activity.questions.quiz) {
      formData.submitted_answers = angular.copy(formData.answers);

      if (Object.keys(formData.answers).length < vm.activity.questions.list.length) {
        return swal('Hold Up!', 'Please complete all of the questions.', 'info');
      }

      const numCorrect = Object.keys(formData.answers).filter(key => answersDict[key] === formData.answers[key]).length;
      const percent = $filter('Progress')(numCorrect, vm.activity.questions.list.length).toFixed(2);

      if (percent < vm.activity.questions.quiz_passing) {
        return Swal.alert(`${percent}% Correct`, 'That is not enough for a passing score. Please try again.', 'info');
      }

      return Swal.alert(`${percent}% Correct`, "You've passed!", 'info')
        .then(() => {
          formData.completed = true;
          return update(formData);
        })
        .catch(error => {
          $log.error(error);
          throw error;
        });
    }

    formData.completed = true;

    if (!vm.activity.questions.quiz) {
      return Swal.confirm('Are you finished?')
        .then(() => update(formData))
        .catch(error => {
          if (error.dismiss) return;
          $log.error(error);
          throw error;
        });
    }

    if (formData.progress) return update(formData);
    create(formData);
  };

  function create(formData) {
    ApiClass.activitiesIdTypePut({ id: $stateParams.activity_id, type: 'progress' }, formData)
      .then(response => {
        $log.debug('Activity Progress Put', response);
        PreviousState.Previous({ Name: '^' });
      })
      .catch(error => {
        $log.error(error);
        swal('Hold Up!', 'Somethings not quite right, please try again', 'error');
        throw error;
      });
  }

  function update(formData) {
    if (vm.activity.progress) {
      return patchProgress(formData);
    } else {
      return putProgress(formData);
    }
  }

  function putProgress(progress) {
    return ApiClass.activitiesIdTypePut(
      { id: $stateParams.activity_id, type_id: profile_uid, type: 'progress' },
      { ...progress, profile_uid }
    )
      .then(response => {
        Swal.toast('Activity Completed');
        $log.debug('Activity Completed', response);
        PreviousState.Previous({ Name: '^' });
      })
      .catch(error => {
        $log.error(error);
        swal('Hold Up!', 'Somethings not quite right, please try again', 'error');
        throw error;
      });
  }

  function patchProgress(progress) {
    progress.updates = vm.activity.progress.updates;
    return ApiClass.activitiesIdTypeTypeIdPatch(
      { id: $stateParams.activity_id, type_id: profile_uid, type: 'progress' },
      { uuid: vm.activity.progress.uuid, ...progress }
    )
      .then(response => {
        Swal.toast('Activity Completed');
        $log.debug('Activity Completed', response);
        PreviousState.Previous({ Name: '^' });
      })
      .catch(error => {
        $log.error(error);
        swal('Hold Up!', 'Somethings not quite right, please try again', 'error');
        throw error;
      });
  }

  function activate() {
    $log.debug('User Activity Activated');
    vm.loaded = false;
    vm.error = {};

    vm.submitted = false;

    if (!$stateParams.activity_id) return (vm.loaded = true);
    ApiClass.activitiesIdGet({ id: $stateParams.activity_id, profile_uid, manage: false })
      .then(({ data: { item: activity } }) => {
        $log.debug('User Activity Data ', activity);

        if (!activity) throw new Error('No Activity');

        if (activity.questions && activity.questions.quiz) {
          activity.questions.list.forEach((question, index) => {
            question.key = index;
            answersDict[index] = question.answer;
          });
        }

        if (activity.questions && activity.questions.quiz_bank) {
          while (activity.questions.quiz_bank <= activity.questions.list.length - 1) {
            activity.questions.list.splice(Math.floor(Math.random() * activity.questions.list.length), 1);
          }
        }

        vm.jotFormId = activity.jotFormId;
        vm.activity = activity;

        if (activity.progress) {
          if (activity.progress.answers) vm.formData.answers = angular.copy(activity.progress.answers);
          if (activity.progress.text_area) vm.formData.text_area = angular.copy(activity.progress.text_area);
        }

        vm.loaded = true;
      })
      .catch(error => {
        $log.error(error);
        vm.loaded = true;
        vm.error = {
          status: true,
          refresh: activate
        };
        throw error;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/controllers/users/activities/activity/controller.js